import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";
import "vant/es/notify/style";
import _Notify from "vant/es/notify";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/4b0429b5-cad2-45c8-80ed-a3346422ad2c/workspace/life-h5_pcAM/node_modules/_@babel_runtime@7.29.7@@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/4b0429b5-cad2-45c8-80ed-a3346422ad2c/workspace/life-h5_pcAM/node_modules/_@babel_runtime@7.29.7@@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/4b0429b5-cad2-45c8-80ed-a3346422ad2c/workspace/life-h5_pcAM/node_modules/_@babel_runtime@7.29.7@@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.dom-collections.for-each.js";
/**
 公共方法
 */
var R = require("ramda");
var wx_loading = false; // 判断是否已经请求的分享数据
var isalertLocation = false; // 判断是否已经弹过一次手动定位

import * as CommindSdk from "../utils/commindSdk";
import storeOption from "../store";

// 创建一个 store 对象用于管理应用状态
var store = new Vuex.Store(storeOption);
var fun = {
  //数组分级===================================
  //this.fun.chunk(json.data.category,8);
  chunk: function chunk(arr, n) {
    var result = [];
    for (var i = 0, len = arr.length; i < len; i += n) {
      result.push(arr.slice(i, i + n));
    }
    return result;
  },
  //合并数组
  sunArr: function sunArr() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return R.concat(name)(params);
  },
  getCookie: function getCookie(cookie_name) {
    var allcookies = document.cookie;
    //索引长度，开始索引的位置
    var cookie_pos = allcookies.indexOf(cookie_name);

    // 如果找到了索引，就代表cookie存在,否则不存在
    if (cookie_pos != -1) {
      // 把cookie_pos放在值的开始，只要给值加1即可
      //计算取cookie值得开始索引，加的1为“=”
      cookie_pos = cookie_pos + cookie_name.length + 1;
      //计算取cookie值得结束索引
      var cookie_end = allcookies.indexOf(";", cookie_pos);
      if (cookie_end == -1) {
        cookie_end = allcookies.length;
      }
      //得到想要的cookie的值
      var value = decodeURIComponent(allcookies.substring(cookie_pos, cookie_end));
    }
    return value;
  },
  //设置微信标题
  setWXTitle: function setWXTitle(title) {
    //debugger;
    if (this.isXueXiApp()) {
      return;
    }
    document.title = title;
    var mobile = navigator.userAgent.toLowerCase();
    // !window.location.href.includes('/o2o/store') 防止门店页面滚动多次触发
    if (/iphone|ipad|ipod/.test(mobile) && !window.location.href.includes("/o2o/store")) {
      var iframe = document.createElement("iframe");
      iframe.style.display = "none";
      // 替换成站标favicon路径或者任意存在的较小的图片即可
      // iframe.setAttribute('src', '/favicon.ico')
      var _iframeCallback = function iframeCallback() {
        setTimeout(function () {
          iframe.removeEventListener("load", _iframeCallback);
          document.body.removeChild(iframe);
        }, 0);
      };
      iframe.addEventListener("load", _iframeCallback);
      document.body.appendChild(iframe);
    }
  },
  //判断是否是空
  isTextEmpty: function isTextEmpty(str) {
    if (str == null || str == "" || str == undefined) {
      return true;
    } else {
      return false;
    }
  },
  //判断手机还是微信
  isWeiXin: function isWeiXin() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return true;
    } else {
      return false;
    }
  },
  //判断是否云打包APP
  isApp: function isApp() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf("yunzshop") > -1) {
      return true;
    } else {
      return false;
    }
  },
  //判断是否聚合CPS的APP
  isCPS: function isCPS() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf("yz_cps") > -1) {
      return true;
    } else {
      return false;
    }
  },
  //判断是否国电投APP
  isWindVane: function isWindVane() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf("windvane") > -1) {
      return true;
    } else {
      return false;
    }
  },
  //判断是否在抖音APP环境
  isDouYinApp: function isDouYinApp() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf("aweme") > -1) {
      return true;
    } else {
      return false;
    }
  },
  // 判断是否在传播大脑融媒客户端环境
  isCommindApp: function isCommindApp() {
    return typeof window.CP2 !== 'undefined' && window.CP2.bridgeType !== undefined;
  },
  //判断是否学习强国APP
  isXueXiApp: function isXueXiApp() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf("xuexi") > -1) {
      return true;
    } else {
      return false;
    }
  },
  // 获取分享回流 token，可通过回流 token 实现分享内容回流到强国客户端，如不需要分享回流功能，无需调用该接口。适用版本2.57.0及以上，JSSDK版本3.6.4及以上
  getXueXiShareToken: function getXueXiShareToken(appKey, url, title, content, image) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            console.log('getXueXiShareToken 参数:', appKey, url, title, content, image);
            return _context.a(2, xuexi.biz.util.getShareToken({
              appKey: appKey || '1030000043672108',
              url: url,
              title: title,
              content: content,
              image: image
            }).then(function (res) {
              console.log('getShareToken 回调结果===', res);
              if (Number(res.code) === 0) {
                return res.token;
              } else {
                throw new Error('获取分享回流 token 失败');
              }
            }));
        }
      }, _callee);
    }))();
  },
  // 封装分享功能的函数，调用学习强国分享功能。适用客户端版本2.55.0及以上，JSSDK版本3.6.4及以上
  shareXueXiContent: function shareXueXiContent(appKey, url, title, content, image) {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var token, _t;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _context2.p = 0;
            _context2.n = 1;
            return _this.getXueXiShareToken(appKey, url, title, content, image);
          case 1:
            token = _context2.v;
            xuexi.biz.util.share({
              appKey: appKey || '1030000043672108',
              type: 0,
              onlyShare: false,
              url: "".concat(url, "&qg_open_token=").concat(token),
              // 点击分享内容后打开的链接地址
              title: title,
              content: content,
              image: image
            }).then(function (res) {
              console.log('xuexi.biz.util.share 回调结果===', res);
            });
            _context2.n = 3;
            break;
          case 2:
            _context2.p = 2;
            _t = _context2.v;
            console.error('xuexi.biz.util.share 分享失败:', _t);
          case 3:
            return _context2.a(2);
        }
      }, _callee2, null, [[0, 2]]);
    }))();
  },
  //判断是否聚合CPS固定的公众号i 和域名
  isCPSAPPI: function isCPSAPPI() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf("yz_cps02") > -1) {
      // yz_cps02才加判断
      var _i = "";
      var _domain = "";
      if (this.isIosOrAndroid() === "ios") {
        _i = getKeyIIOS().i;
        _domain = getKeyIIOS().domain;
      } else {
        _i = getKeyIAndroid().i;
        _domain = getKeyIAndroid().domain;
      }
      var cpsHost = _domain.split('://')[1]; //截取域名，只比对域名
      console.log('判断是否聚合CPS固定的公众号i==========', cpsHost, window.location.host);
      return cpsHost == window.location.host && _i == this.getKeyByI();
      // return _domain == this.getSiteRoot() && _i == this.getKeyByI();
    } else {
      return true;
    }
  },
  //判断支付宝环境
  isAlipay: function isAlipay() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/Alipay/i) == "alipay") {
      return true;
    } else {
      return false;
    }
  },
  isWalletApp: function isWalletApp() {
    // 是否为钱包app 环境
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf("wallet") > -1) {
      return true;
    } else {
      return false;
    }
  },
  getSiteRoot: function getSiteRoot() {
    return document.location.protocol + "//" + window.location.host;
  },
  getKey: function getKey(name) {
    var _i = decodeURIComponent((new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(location.href) || [, ""])[1].replace(/\+/g, "%20")) || null;
    if (name == "i") {
      return String(_i).replace(/[^0-9]/gi, ""); //过滤i非数字
    } else {
      return _i;
    }
  },
  getKeyByI: function getKeyByI() {
    var i = this.getKey("i");
    return i;
  },
  getKeyByMid: function getKeyByMid() {
    var mid = 0;
    if (!this.getKey("mid") && this.getKey("i") && this.getKey("i") == window.localStorage.i) {
      // this.getKey("i") && this.getKey("i") == window.localStorage.i   防止同一站点不同平台来回扫码时，把上一个平台的mid 赋值给下一个扫码的平台
      mid = window.localStorage.uid || 0;
    } else {
      mid = this.getKey("mid");
    }
    return mid;
  },
  getKeyByMicroShopId: function getKeyByMicroShopId() {
    var micro_shop_id = this.getKey("shop_id");
    return micro_shop_id;
  },
  getSession: function getSession() {
    return this.getKey("session");
  },
  getToken: function getToken() {
    return this.getKey("token");
  },
  getOpenid: function getOpenid() {
    return this.getKey("openid");
  },
  getTyep: function getTyep() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (window.isMiniprogram) {
      // 小程序 在小程序webview 里面走wap端的type
      return "5";
    }
    if (this.getToken()) {
      return "2";
    }
    if (this.isWXWork()) {
      return "17";
    } else if (ua.match(/MicroMessenger/i) == "micromessenger") {
      // 微信浏览器
      return "1";
    } else if (this.isApp()) {
      return "7";
    } else if (this.isAlipay()) {
      return "8";
    } else if (this.isWalletApp()) {
      //钱包app二开【#4203】
      return "18";
    } else if (this.isWindVane()) {
      //国电投app
      return "20";
    } else if (this.isDouYinApp()) {
      //抖音app
      return "21";
    } else if (this.isCommindApp()) {
      //传播大脑融媒客户端
      return "22";
    } else {
      return "5";
    }
  },
  isWXWork: function isWXWork() {
    // 检查企业微信环境
    var ua = navigator.userAgent.toLowerCase();
    return ua.match(/wxwork/i) == "wxwork";
  },
  isPc: function isPc() {
    if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
      return false;
    } else {
      return true;
    }
  },
  browserRedirect: function browserRedirect(url) {
    //只读的字符串，声明了浏览器用于 HTTP 请求的用户代理头的值
    var sUserAgent = navigator.userAgent.toLowerCase();
    var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
    var bIsMidp = sUserAgent.match(/midp/i) == "midp";
    var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
    var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
    var bIsAndroid = sUserAgent.match(/android/i) == "android";
    var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
    var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
    var all = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    if (!(bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM || all)) {
      window.location.replace(url);
    }
  },
  //url增加默认传参
  getUrl: function getUrl(name, params, query) {
    var _query = {
      // i: this.getKeyByI(),
      // type: this.getTyep(),
      // shop_id: this.getKeyByMicroShopId()
      //token:this.getToken(),
      //session:this.getSession(),
    };
    // 传递tid参数
    var tid = this.getKey('tid');
    if (tid) {
      _query.tid = tid;
    }
    var access_token = this.getKey('access_token');
    if (access_token) {
      _query.access_token = access_token;
    }
    if (this.getKeyByMid()) {
      // 防止mid = undefined
      _query.mid = this.getKeyByMid();
    }
    var supplier_alone_id = this.getKey('supplier_alone_id') || sessionStorage.getItem("supplier_alone_id") || null; //供应商独立模板，获取供应商id
    if (supplier_alone_id) {
      _query.supplier_alone_id = supplier_alone_id;
    }
    query = R.mergeAll([query, _query]);
    return {
      name: name,
      params: params,
      query: query
    };
  },
  getRealUrl: function getRealUrl(url, params) {
    var i = this.getKeyByI();
    var mid = this.getKeyByMid();
    var type = this.getTyep();
    var shop_id = this.getKeyByMicroShopId();
    var baseUrl = "";
    if (mid) {
      baseUrl = "/?i=" + i + "&mid=" + mid + "&type=" + type + "&shop_id=" + shop_id + "&route=";
    } else {
      baseUrl = "/?i=" + i + "&type=" + type + "&shop_id=" + shop_id + "&route=";
    }
    if (params) {
      var paramsArray = [];
      Object.keys(params).forEach(function (key) {
        return paramsArray.push(key + "=" + params[key]);
      });
      url += "&" + paramsArray.join("&");
      url = baseUrl + url;
    } else {
      url = baseUrl + url;
    }
    return url;
  },
  //获取地址信息
  getAddressInfo: function getAddressInfo() {
    //saveAddresssInfo
    $http.get("member.member-address.address", {
      i: this.getKeyByI(),
      type: this.getTyep()
    }).then(function (response) {
      if (response.result == 1) {
        var province = JSON.stringify(response.data.province);
        var city = JSON.stringify(response.data.city);
        var district = JSON.stringify(response.data.district);
        localStorage.setItem("province", province);
        localStorage.setItem("city", city);
        localStorage.setItem("district", district);
      }
    }, function (response) {
      // error callback
    });
  },
  //酒店插件自定义字段
  // getCustomizeHotelHead() {
  // 	$http
  // 	.get('plugin.hotel.frontend.hotel.get-hotel-info.get-custom-name', {}, "加载中...")
  // 	.then(response => {
  // 	  if (response.result == 1) {
  // 		localStorage.setItem("customizeHotelHead", JSON.stringify(response.data));
  // 	  }
  // 	})
  // 	.catch(error => {
  // 	  console.log(error);
  // 	});
  // },

  //如果为空
  isNonEmpty: function isNonEmpty(value, errorMsg) {
    return value === "" ? errorMsg : void 0;
  },
  //最小长度
  minLength: function minLength(value, length, errorMsg) {
    return value.length < length ? errorMsg : void 0;
  },
  //是否手机
  isMoblie: function isMoblie(value) {
    //return !/^1(3|5|7|8|9)[0-9]{9}$/.test(value);
    // return !/^1\d{10}$/.test(value);

    return !/^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/.test(value);
  },
  //是否Email
  isEmail: function isEmail(value, errorMsg) {
    return !/^\w+([+-.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value) ? errorMsg : void 0;
  },
  //是否为URL链接
  isUrl: function isUrl(value) {
    return !/^((https|http):\/\/).+$/g.test(value);
  },
  //判断URL链接中是否有mid如果有
  isMid: function isMid(url) {
    var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (url.indexOf("mid=") >= 0) {
      return this.changeUrlArg(url, "mid", val);
    } else {
      var burl = this.delQueStr(url, "mid");
      return this.changeUrlArg(burl, "mid", val);
    }
  },
  changeUrlArg: function changeUrlArg(url, arg, val) {
    var pattern = arg + "=([^&]*)";
    var replaceText = arg + "=" + val;
    var regex = new RegExp("(" + arg + "=)([^&]*)", "gi");
    return url.match(pattern) ? url.replace(regex, replaceText) : url.match("[?]") ? url + "&" + replaceText : url + "?" + replaceText;
  },
  delQueStr: function delQueStr(url, ref) {
    //删除参数值

    var str = "";
    if (url.indexOf("#") != -1) {
      str = url.substr(url.indexOf("#") + 1);
      // console.log("urlTga", str);
    } else {
      return url;
    }
    var arr = "";
    var returnurl = "";
    if (str.indexOf("&") != -1) {
      arr = str.split("&");
      console.log("arr", arr);
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].split("=")[0] != ref) {
          returnurl = returnurl + arr[i].split("=")[0] + "=" + arr[i].split("=")[1] + "&";
        }
      }
      console.log("returnurl", returnurl);
      return url.substr(0, url.indexOf("?")) + "?menu=#" + returnurl.substr(0, returnurl.length - 1);
    } else {
      arr = str.split("=");
      if (arr[0] == ref) return url.substr(0, url.indexOf("?"));else return url;
    }
  },
  //判断是否在云打包的应用中
  isapp: function isapp() {
    var YundabaoUA = navigator.userAgent; //获取当前的useragent
    if (YundabaoUA.indexOf("CK 2.0") > -1) {
      //判断当前的ua中是否包含"CK 2.0"，如果包含"CK 2.0"标识当前在云打包的应用中
      return true;
    } else {
      return false;
    }
  },
  //判断URL链接中是否有shop_id如果有
  isShopId: function isShopId(url, val) {
    if (url.indexOf("shop_id=") >= 0) {
      return this.changeUrlArg(url, "shop_id", val);
    } else {
      var burl = this.delQueStr(url, "shop_id");
      return this.changeUrlArg(burl, "shop_id", val);
    }
  },
  //获取时间戳
  getTimestamp: function getTimestamp(vales) {
    var timestamp = Date.parse(new Date(vales));
    return timestamp / 1000;
  },
  // 时间戳差值
  getTimeDifference: function getTimeDifference(Timestamp) {
    var now = Date.parse(new Date());
    // console.log("Timestamp", Timestamp);
    var time = Timestamp < 1000000000000 ? Timestamp * 1000 : Timestamp;
    // console.log(time - now);
    if (time - now > 0) {
      return time - now;
    } else if (time - now <= 0) {
      return 0;
    }
  },
  //将时间对象转换成自定义正常时间格式
  dateFormat: function dateFormat(fmt, date) {
    var ret;
    var opt = {
      "Y+": date.getFullYear().toString(),
      // 年
      "m+": (date.getMonth() + 1).toString(),
      // 月
      "d+": date.getDate().toString(),
      // 日
      "H+": date.getHours().toString(),
      // 时
      "M+": date.getMinutes().toString(),
      // 分
      "S+": date.getSeconds().toString() // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (var k in opt) {
      ret = new RegExp("(" + k + ")").exec(fmt);
      if (ret) {
        fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0"));
      }
    }
    return fmt;
  },
  //将时间戳转换成正常时间格式
  timestampToTime: function timestampToTime(timestamp) {
    if (!Number(timestamp) || timestamp == "") {
      return "";
    }
    var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + ".";
    var M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + ".";
    var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
    var h = (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
    var m = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    return Y + M + D + h + m;
  },
  //兼容 将时间戳转换成正常时间格式
  timestampToTime_new: function timestampToTime_new(timestamp) {
    if (!Number(timestamp) || timestamp == "") {
      return "";
    }
    var dateStr = this.getPhoneEnv() == 1 ? '/' : '-';
    var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + dateStr;
    var M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + dateStr;
    var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
    var h = (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
    var m = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    return Y + M + D + h + m;
  },
  timeCountDown: function timeCountDown(times) {
    // 将时间戳转换成倒计时
    // time 属性表示倒计时总时长，单位为毫秒。
    var timestamp = new Date().getTime();
    if (times >= 1000000000000 && times < timestamp || times < 1000000000 && times * 1000 < timestamp) {
      return "已结束";
    }
    var time = times >= 1000000000000 ? (times - timestamp) / 1000 : (times * 1000 - timestamp) / 1000;
    console.log(time);
    var day = parseInt(time / 60 / 60 / 24);
    var hour = parseInt(time / 60 / 60 % 24);
    var minute = parseInt(time / 60 % 60);
    var seconds = parseInt(time % 60);
    return day + "天" + hour + "小时" + minute + "分钟" + seconds + "秒";
  },
  // 判断是否为金额
  isPriceNumber: function isPriceNumber(obj) {
    var isNum = /^\d+(\.\d+)?$/;
    if (!isNum.test(obj)) {
      return false;
    } else {
      return true;
    }
  },
  initMailLanguage: function initMailLanguage() {
    return JSON.parse(localStorage.getItem("mailLanguage"));
  },
  /*
  * @desc 获取深层级对象的属性
  * @param {Object} target - 目标对象
  * #param {String} path="" - 目标属性的路径
  */
  getDeepJsonValue: function getDeepJsonValue(target) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var escapeRegExp = function escapeRegExp(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    };
    path = path.replace(new RegExp(escapeRegExp("["), "g"), '.');
    path = path.replace(new RegExp(escapeRegExp("]"), "g"), '');
    try {
      return path.split('.').reduce(function (target, key) {
        return target[key];
      }, target);
    } catch (e) {
      return undefined;
    }
  },
  /*
  * @desc 获取localStorage.getItem("mailLanguage")中存储的自定义字样;
  * @param {String} path - 目标属性的路径
  * @param {String} defaultText="" - 默认的字样
  */
  getCustomTextLang: function getCustomTextLang(path) {
    var defaultText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var language = this.initMailLanguage();
    var projectLang = this.getDeepJsonValue(language, path);
    return projectLang || defaultText;
  },
  /*
  * @desc 获取localStorage.getItem("globalParameter")中存储的字段;
  * @param {String} path - 目标属性的路径
  * @param {String} defaultText="" - 默认的字样
  * 使用方法 {{fun.getGlobalParameter(name,'默认值')}} 或者 this.fun.getGlobalParameter(name,'默认值')
  */
  getGlobalParameter: function getGlobalParameter(path) {
    var defaultText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var language = JSON.parse(window.localStorage.getItem('globalParameter')) || {};
    var projectLang = this.getDeepJsonValue(language, path);
    return projectLang || defaultText;
  },
  /*
  * @desc 获取localStorage.getItem("plugin_setting")中存储的字段;
  * @param {String} path - 目标属性的路径
  * @param {String} defaultText="" - 默认的字样
  * 使用方法 {{fun.getPluginSetting(name,'默认值')}} 或者 this.fun.getPluginSetting(name,'默认值')
  */
  getPluginSetting: function getPluginSetting(path) {
    var defaultText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var language = JSON.parse(window.localStorage.getItem('plugin_setting')) || {};
    var projectLang = this.getDeepJsonValue(language, path);
    return projectLang || defaultText;
  },
  //自定义提现字段
  initWithdrawal: function initWithdrawal() {
    var name_of_withdrawal = JSON.parse(localStorage.getItem("mailLanguage"));
    if (name_of_withdrawal) {
      return name_of_withdrawal.income.name_of_withdrawal;
    } else {
      return {};
    }
  },
  // 自定义余额字样
  getBalanceLang: function getBalanceLang() {
    var balanceLang = localStorage.getItem("balanceLang");
    return balanceLang || "余额";
  },
  //自定义积分字样
  getIntegralLang: function getIntegralLang() {
    var integralLang = localStorage.getItem("integralLang");
    return integralLang || "积分";
  },
  setMailLanguage: function setMailLanguage(defaultStr, languageStr) {
    var language = this.isTextEmpty(languageStr) ? defaultStr : languageStr;
    return language;
  },
  getPrice: function getPrice() {
    //获取商品语言设置的现价（全部商品、搜索、品牌、分类列表搜索页）
    var MarketPrice = JSON.parse(localStorage.getItem("mailLanguage"));
    if (MarketPrice.goods && MarketPrice.goods.price) {
      return MarketPrice.goods.price;
    }
  },
  getMarketPrice: function getMarketPrice() {
    //获取商品语言设置的原价（全部商品、搜索、品牌、分类列表搜索页）
    var MarketPrice = JSON.parse(localStorage.getItem("mailLanguage"));
    if (MarketPrice.goods && MarketPrice.goods.market_price) {
      return MarketPrice.goods.market_price != "" ? MarketPrice.goods.market_price : "原价";
    }
    return "原价";
  },
  funHrefFilters: function funHrefFilters(url) {
    if (url == null || url == "" || url == undefined) {
      return "javascript:;";
    }
    var host = document.location.host;
    //let mid=decodeURIComponent((new RegExp('[?|&]' + "mid" + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
    var mid = window.localStorage.getItem("uid");
    if (url.indexOf(host) >= 0) {
      return url + "&mid=" + mid;
    } else {
      return url;
    }
  },
  funHrefFilters1: function funHrefFilters1(url) {
    if (url == null || url == "" || url == undefined) {
      return "javascript:;";
    }
    var mid = window.localStorage.getItem("uid");
    return url + "&mid=" + mid;
  },
  deeplinkURL: function deeplinkURL(url) {
    //判断链接是否已拼接了?,有则返回拼接&
    var deeplink_url = url; //当前链接
    if (deeplink_url.indexOf("?") != -1) {
      deeplink_url = deeplink_url + '&';
    } else {
      deeplink_url = deeplink_url + '?';
    }
    return deeplink_url;
  },
  //判断当前web环境 5代表pc浏览器环境 2代表小程序环境 1代表微信公众号网页环境
  //判断是否是小程序----res.miniprogram为true代表在小程序里,false代表在公众号里 没用
  getWebEnv: function getWebEnv() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      try {
        wx.miniProgram.getEnv(function (res) {
          if (res.miniprogram) {
            return "2";
          } else {
            return "1";
          }
        });
      } catch (e) {
        return "1";
      }
    } else {
      return "5";
    }
  },
  bd_decrypt: function bd_decrypt(bd_lng, bd_lat) {
    var X_PI = Math.PI * 3000.0 / 180.0;
    var x = bd_lng - 0.0065;
    var y = bd_lat - 0.006;
    var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * X_PI);
    var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * X_PI);
    var gg_lng = z * Math.cos(theta);
    var gg_lat = z * Math.sin(theta);
    return {
      lng: gg_lng,
      lat: gg_lat
    };
  },
  //高德坐标转百度（传入经度、纬度）
  bd_encrypt: function bd_encrypt(gg_lng, gg_lat) {
    var X_PI = Math.PI * 3000.0 / 180.0;
    var x = gg_lng,
      y = gg_lat;
    var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * X_PI);
    var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * X_PI);
    var bd_lng = z * Math.cos(theta) + 0.0065;
    var bd_lat = z * Math.sin(theta) + 0.006;
    return {
      lat: bd_lat,
      lng: bd_lng
    };
  },
  //判断微信下ios和安卓 ios为1 安卓为2 其他3
  getPhoneEnv: function getPhoneEnv() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || this.isApp(); //ios终端或者云打包
    var isIpad = u.indexOf("Intel Mac OS") > -1 && u.indexOf("Chrome") === -1 && u.indexOf("Safari") === -1 && u.indexOf("Firefox") === -1;
    if (isAndroid) {
      return "2";
    } else if (isIOS || isIpad) {
      return "1";
    } else {
      return "3";
    }
  },
  //判断微信版本是否大于6.7.2，兼容js-dk1.40和1.3.2
  getWechatVersion: function getWechatVersion() {
    if (this.isWeiXin()) {
      var wechatInfo = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i);
      var wechatVersion = wechatInfo[1];
      var version_arr = wechatVersion.split(".");
      if (Number(version_arr[0] > 6)) {
        return true;
      } else if (Number(version_arr[0] == 6)) {
        if (Number(version_arr[1]) > 7) {
          return true;
        } else if (version_arr[1] == 7) {
          if (Number(version_arr[2]) >= 2) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
  // 判断ios还是android
  isIosOrAndroid: function isIosOrAndroid() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
    var isStr = "";
    if (isAndroid) {
      isStr = "android";
    }
    if (isiOS) {
      isStr = "ios";
    }
    return isStr;
  },
  isIphoneX: function isIphoneX() {
    if (/iphone/gi.test(window.navigator.userAgent)) {
      /* iPhone X、iPhone XS */
      var x = window.screen.width === 375 && window.screen.height === 812;
      var xUp = window.screen.height >= 812;
      if (x || xUp) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
  isIphone: function isIphone() {
    if (/iphone/gi.test(window.navigator.userAgent)) {
      return true;
    } else {
      return false;
    }
  },
  //键盘顶起页面后隐藏不回弹解决方案
  clearSrcoll: function clearSrcoll() {
    var currentPosition, timer;
    var speed = 1; //页面滚动距离
    timer = setInterval(function () {
      currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
      currentPosition -= speed;
      window.scrollTo(0, currentPosition); //页面向上滚动
      currentPosition += speed; //speed变量
      window.scrollTo(0, currentPosition); //页面向下滚动
      clearInterval(timer);
    }, 1);
  },
  getRouter: function getRouter() {
    //获取网址的路由
    return window.location.href.match(/\#\/(\S*)\?/)[1];
    // return window.location.href.match(/(?<=\#\/).*(?=\?)/)[0]
  },
  // 辅助导航方法
  checkGetLocation: function checkGetLocation(point, title, address, city) {
    var _this2 = this;
    // console.log(point, 'point1');
    if (this.isWeiXin()) {
      // 微信环境比较准确
      window.AMap.plugin("AMap.Geocoder", function () {
        var geocoder = new window.AMap.Geocoder({
          // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
          city: city
        });
        geocoder.getLocation(address, function (status, result) {
          if (status === "complete" && result.info === "OK") {
            // result中对应详细地理坐标信息
            point = result.geocodes[0].location;
            // console.log(point, 'point2');
            _this2.toAddress(point, title, address);
          } else {
            console.error("根据地址查询位置失败");
            _this2.toAddress(point, title, address);
          }
        });
      });
    } else {
      this.toAddress(point, title, address);
    }
  },
  // 辅助导航方法
  toAddress: function toAddress(point, title, address) {
    if (this.isWeiXin()) {
      $http.post("member.member.wxJsSdkConfig", {
        url: this.isIosOrAndroid() === "ios" ? window.initUrl : document.location.href
      }, " ").then(function (response) {
        if (response.result === 1) {
          if (response.data.config) {
            wx.config({
              debug: false,
              appId: response.data.config.appId,
              nonceStr: response.data.config.nonceStr,
              timestamp: response.data.config.timestamp,
              url: response.data.config.url,
              signature: response.data.config.signature,
              jsApiList: ["checkJsApi", "openLocation", "getLocation"]
            });
            wx.checkJsApi({
              jsApiList: ["getLocation"],
              success: function success(res) {
                if (res.checkResult.getLocation == false) {
                  alert("你的微信版本太低，不支持微信JS接口，请升级到最新的微信版本！");
                }
              },
              fail: function fail(err) {
                console.log(err);
              }
            });
            wx.ready(function () {
              // wx.getLocation({
              //   type: "gcj02", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
              //   success: function(res) {

              // 直接调用openLocation就行
              setTimeout(function () {
                wx.openLocation({
                  latitude: point.lat,
                  // 纬度，浮点数，范围为90 ~ -90
                  longitude: point.lng,
                  // 经度，浮点数，范围为180 ~ -180。
                  name: title,
                  // 位置名
                  address: address || "详细地址",
                  // 地址详情说明
                  scale: 20 // 地图缩放级别,整形值,范围从1~28。默认为最大
                });
              }, 200);
              // },
              //   cancel: function(res) {
              //     alert("用户拒绝授权获取地理位置");
              //   }
              // });
            });
            wx.error(function (response) {
              console.log(response);
              window.location.href = "https://uri.amap.com/navigation?to=".concat(point.lng, ",").concat(point.lat, ",").concat(title, "&mode=car&policy=1&src=mypage&coordinate=gaode&callnative=0");
            });
          } else {
            window.location.href = "https://uri.amap.com/navigation?to=".concat(point.lng, ",").concat(point.lat, ",").concat(title, "&mode=car&policy=1&src=mypage&coordinate=gaode&callnative=0");
          }
        } else {
          window.location.href = "https://uri.amap.com/navigation?to=".concat(point.lng, ",").concat(point.lat, ",").concat(title, "&mode=car&policy=1&src=mypage&coordinate=gaode&callnative=0");
        }
      }, function (response) {
        console.log(response);
        window.location.href = "https://uri.amap.com/navigation?to=".concat(point.lng, ",").concat(point.lat, ",").concat(title, "&mode=car&policy=1&src=mypage&coordinate=gaode&callnative=0");
      });
    } else {
      // 非微信环境
      window.location.href = "https://uri.amap.com/navigation?to=".concat(point.lng, ",").concat(point.lat, ",").concat(title, "&mode=car&policy=1&src=mypage&coordinate=gaode&callnative=0");
    }
  },
  /**
   * 点击导航方法
   * @param {object} point 导航的经纬度 {lat: '',lng:''},通常要经过bd_decrypt
   * @param {string} title 微信导航的地址位置名
   * @param {string} address 微信导航的地址详情说明
   * @param {string} city 城市名称（不是必传，传了会先用高德正向地理编码获取经纬度） 暂不要city
   */
  goToWXAdress: function goToWXAdress(point, title, address) {
    // if(city) {
    // // 保留 但根据地址定位不够准确
    //   this.checkGetLocation(point, title, address, city);
    // }else {
    this.toAddress(point, title, address);
    // }
  },
  /**
   *
   * @param {string} url 分享的Url。为空会根据环境换取当前页面地址
   * @param {object} data 请求的数据
   * @param {object} shareConfig 微信分享配置信息 title description imgUrl type? dataUrl? link?
   * @param {function} shareFun 微信分享获取配置信息后回调方法
   * @param {function} callback 微信分享成功后回调方法
   * @param {function} readyFun wx.ready后回调方法
   * @return {object} response 后端数据
   */
  wxShare: function wxShare() {
    var _this3 = this;
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var shareConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var shareFun = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var callback = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var readyFun = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
    if (this.getTyep() == 5 || this.getTyep() == 18 || this.getTyep() == 17 || this.getTyep() == 20 || wx_loading) {
      return "";
    }

    //以下是需要单独设置分享的页面链接
    var list = ["/diy", "/homeseller", "/o2o/store_v2", "/o2o/store", "/o2o/home/homeseller/", "/share_page_detail", "/business_activity/business_activity", "/voice_good/", "/activity/task/list/", "/supplier_shop/", "/o2o/store", "/o2o/storeApply", "/grabGroupHome", "/grabGroup", "/community_buying/buying_personal/", "/community_solitaire/", "/group_list", "/group_detail", "/wx-scheme-tool", "/member/blindBoxDetail", "/member/redEnvelope/", "/others/integral_shop", "/workWechatSidebar/index", "/workWechatSidebar", "/articleContent/", "/workWx/sopPushTask", "/workWx/sopTaskList", "/workWx/sopTaskDetail", "/workWx/speechLibrary", "/workWx/customerStatistic", "/workWx/memberRecordDetail", "/workWx/wxWorkChatTransfer", "/microRelease", "/microEdit", "/member/courseindex", "/member/payanother/", "/conference/activity/", "/enrollEnter/", '/activityHome'];
    for (var i = 0; i < list.length; i++) {
      // 编程式
      if (window.location.href.indexOf(list[i]) > -1 && shareConfig.share_from === "app") {
        return false;
      }
    }
    if (!url) {
      url = this.isIosOrAndroid() === "ios" ? window.initUrl : document.location.href;
    }
    var requestData = _objectSpread({
      url: url
    }, data);
    return new Promise(function (resolve, reject) {
      if (window.yz_share_data && window.yz_share_data.config) {
        console.log(window.yz_share_data.config, "11");
        wx_loading = false;
        if (window.yz_share_data.config && window.yz_share_data.config.appId) {
          try {
            if (shareFun) {
              shareFun(window.yz_share_data);
            }
            _this3.dealShare(shareConfig, window.yz_share_data, callback, readyFun);
            resolve(window.yz_share_data);
          } catch (e) {
            reject(e);
          }
        }
      } else {
        wx_loading = true;
        // $http.post("member.member.wxJsSdkConfig", requestData).then(
        //     response => {
        //         if (response.result === 1) {
        //             if (response.data.config && response.data.config.appId) {
        //                 if (shareFun) {
        //                     shareFun(response.data);
        //                 }
        //                 wx_loading = false;
        //                 response.data.config.openTagList = ["wx-open-launch-weapp", "wx-open-subscribe", "ww-open-data", "wx-open-launch-app"];
        //                 window.yz_share_data = response.data;
        //                 // console.log("wx share - ",shareConfig, requestData);
        //                 console.log(window.yz_share_data.config);
        //                 wx.config(window.yz_share_data.config);
        //                 wx.error(res => {
        //                     console.log("wxShare()::config信息验证失败！" + JSON.stringify(res));
        //                 });
        //                 this.dealShare(shareConfig, response.data, callback, readyFun);
        //                 resolve(response.data);
        //             }
        //         } else {
        //             reject(response.msg);
        //         }
        //     },
        //     error => {
        //         reject(error);
        //     }
        // );
      }
    });
  },
  /**
   *
   * @param {object} shareConfig 微信分享配置信息 title description imgUrl type? dataUrl? link?
   * @param {object} data 微信配置接口返回的数据
   * @param {function} callback 微信分享成功后回调方法
   * @param {function} readyFun wx.ready后回调方法
   */
  dealShare: function dealShare(shareConfig, data) {
    var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var readyFun = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var _link, menuLists;
    if (shareConfig.hideMenu) {
      menuLists = shareConfig.hideMenu;
    }
    if (shareConfig.link) {
      _link = this.isMid(shareConfig.link, data.info.uid);
    } else {
      _link = document.location.href + "&share_tag=2";
      _link = this.isMid(_link, data.info.uid);
    }
    _link = _link + '&shrID=' + data.info.uid; //分享者id,避免其他用户进入后跳转页面后刷新与自己的mid冲突

    // 自提点供应商配置
    var deliverID = sessionStorage.getItem("deliverId") || null;
    if (deliverID || window.location.href.indexOf("deliverId") > -1) {
      if (window.location.href.indexOf("deliverId") > -1 && deliverID) {
        var font_url = _link.split("deliverId")[0];
        var back_url = _link.split("deliverId")[0];
        var new_back_url = back_url.match(/\&(.*)/)[1];
        _link = "".concat(font_url, "deliverId=").concat(deliverID, "&").concat(new_back_url);
      } else if (deliverID) {
        _link = _link + "&deliverId=" + deliverID;
      }
    }
    // 自提点供应商  end

    if (shareConfig.title === "向您分享优惠券") {
      // 需要data.info.nickname单独处理
      shareConfig.title = "".concat(data.info.nickname, "\u5411\u60A8\u5206\u4EAB\u4F18\u60E0\u5238");
    }
    wx.ready(function () {
      wx.showOptionMenu();
      if (readyFun) {
        readyFun();
      }
      wx.onMenuShareTimeline({
        title: shareConfig.title ? shareConfig.title : data.shop.share && !data.shop.share.title ? data.shop.shop ? data.shop.shop.name : '' : data.shop.share.title,
        // 分享标题
        link: _link,
        // 分享链接
        imgUrl: shareConfig.imgUrl ? shareConfig.imgUrl : data.shop.share && !data.shop.share.icon ? data.shop.icon : data.shop.share.icon,
        // 分享图标
        success: function success() {
          _Toast("分享成功");
          if (callback) {
            callback();
          }
        },
        cancel: function cancel() {
          _Toast("取消分享");
        }
      });
      // 隐藏分享选项
      wx.hideMenuItems({
        menuList: menuLists ? menuLists : ""
      });
      wx.onMenuShareAppMessage({
        title: shareConfig.title ? shareConfig.title : data.shop.share && !data.shop.share.title ? data.shop.shop ? data.shop.shop.name : '' : data.shop.share.title,
        // 分享标题
        desc: shareConfig.description ? shareConfig.description : data.shop.share && !data.shop.share.desc ? data.shop.shop ? data.shop.shop.name : '' : data.shop.share.desc,
        // 分享描述
        link: _link,
        // 分享链接
        imgUrl: shareConfig.imgUrl ? shareConfig.imgUrl : data.shop.share && !data.shop.share.icon ? data.shop.icon : data.shop.share.icon,
        // 分享图标
        type: shareConfig.type ? shareConfig.type : "link",
        // 分享类型,music、video或link，不填默认为link
        dataUrl: ["music", "video"].includes(shareConfig.type) ? shareConfig.dataUrl : "",
        // 如果type是music或video，则要提供数据链接，默认为空
        success: function success() {
          _Toast("分享成功");
          if (callback) {
            callback();
          }
        },
        cancel: function cancel() {
          _Toast("取消分享");
        }
      });
    });
  },
  getSubdomain: function getSubdomain() {
    // 获取当前主机名
    var hostname = window.location.hostname;
    // 将主机名拆分为数组
    var parts = hostname.split('.');
    // 检查数组长度以确定是否存在子域
    if (parts.length > 2) {
      // 返回子域，数组的第一个元素是子域
      return parts.slice(0, -2).join('.');
    }
    // 如果没有子域，返回空字符串
    return '';
  },
  delay: function delay(ms) {
    return new Promise(function (resolve) {
      return setTimeout(resolve, ms);
    });
  },
  //定位
  getLocation: function getLocation(loading_txt) {
    var _this4 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var that, exitTime, isOverTime, myLocation, nowTiem, localTime, effectiveDuration, subdomain, isEffective, _isPositionPower, _t2;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            that = _this4;
            exitTime = 30 * 1000; //控制30秒超时
            isOverTime = false; // 超时直接执行onError，并不再往下执行
            myLocation = JSON.parse(localStorage.getItem("myLocation"));
            nowTiem = Math.round(new Date() / 1000); //当前时间戳
            localTime = myLocation && myLocation.timestamp ? myLocation.timestamp : 0; //缓存的时间戳
            // 如果是测试环境，缓存为30天。如果是线上正式环境，缓存为15分钟，过期重新请求更新定位信息
            effectiveDuration = 900; // 如果当前域名以dev、release、localhost开头，则缓存时间为30天，否则为15分钟
            subdomain = _this4.getSubdomain();
            if (subdomain.indexOf("dev") > -1 || subdomain.indexOf("release") > -1 || window.location.hostname.indexOf("localhost") > -1) {
              console.log('测试环境，定位信息缓存时效：30天');
              effectiveDuration = 2592000;
            }
            isEffective = !!(localTime && nowTiem - localTime < effectiveDuration); //是否在有效期时长内
            if (!_this4.isCPS()) {
              _context3.n = 6;
              break;
            }
            if (isEffective) {
              _context3.n = 1;
              break;
            }
            _Notify({
              type: 'danger',
              duration: 2500,
              message: '位置信息权限使用说明:用于查询附近、线下导航服务等场景'
            });
            _context3.n = 1;
            return _this4.delay(1000);
          case 1:
            _context3.p = 1;
            _isPositionPower = cps.orientationAndroid(); //查询是否已经授权过定位权限，用于处理个别机型拒绝定位权限后闪屏卡死
            if (!(Number(_isPositionPower) == '2000')) {
              _context3.n = 2;
              break;
            }
            _Toast.fail('定位权限未开启，请开启后刷新网页重试');
            return _context3.a(2);
          case 2:
            if (!(Number(_isPositionPower) == '-1 ')) {
              _context3.n = 4;
              break;
            }
            _context3.n = 3;
            return _this4.delay(6000);
          case 3:
            // 等待 6 秒
            // 执行代码
            _isPositionPower = cps.orientationAndroid();
            if (!(Number(_isPositionPower) == '2000')) {
              _context3.n = 4;
              break;
            }
            _Toast.fail('还是没开启定位权限');
            return _context3.a(2);
          case 4:
            _context3.n = 6;
            break;
          case 5:
            _context3.p = 5;
            _t2 = _context3.v;
            console.log(_t2);
          case 6:
            if (loading_txt) {
              _Toast.loading({
                duration: 0,
                // 持续展示 toast
                message: loading_txt,
                forbidClick: true
              });
            }
            console.log("fun.js getLocation() 定位中....... isEffective有效期", isEffective);
            return _context3.a(2, new Promise(function (resolve, reject) {
              if (!isEffective || !myLocation || !myLocation.point) {
                var onComplete = function onComplete(obj) {
                  try {
                    _Notify.clear();
                  } catch (error) {}
                  if (isOverTime) {
                    return;
                  }
                  clearTimeout(location_overtime);
                  // let res =
                  //   '经纬度：' +
                  //   obj.position +
                  //   '\n精度范围：' +
                  //   obj.accuracy +
                  //   '米\n定位结果的来源：' +
                  //   obj.location_type +
                  //   '\n状态信息：' +
                  //   obj.info +
                  //   '\n地址：' +
                  //   obj.formattedAddress +
                  //   '\n地址信息：' +
                  //   JSON.stringify(obj.addressComponent, null, 4);
                  //alert(JSON.stringify(obj.addressComponent, null, 4));
                  var position = obj.position.toString().split(",");
                  var point = {
                    lat: position[1],
                    lng: position[0]
                  };
                  var city = obj.addressComponent && obj.addressComponent.city ? obj.addressComponent.city : obj.addressComponent && obj.addressComponent.province ? obj.addressComponent.province : "";
                  var addressComponent = obj.addressComponent;
                  var pos = {
                    addressComponent: addressComponent || {},
                    address: obj.formattedAddress,
                    city: city,
                    title: obj.formattedAddress,
                    point: point,
                    timestamp: Math.round(new Date() / 1000)
                  };
                  localStorage.setItem("myLocation", JSON.stringify(pos));
                  console.log("fun.js getLocation()定位成功：：：", pos);
                  store.commit("updateLocation", pos);
                  store.commit("setLocation", pos);
                  _Toast.clear();
                  resolve(pos);
                };
                var onError = function onError(err) {
                  try {
                    _Notify.clear();
                  } catch (error) {}
                  if (isOverTime) {
                    return;
                  }
                  clearTimeout(location_overtime);
                  store.commit("setReferer", window.location.href);
                  _Toast.clear();
                  // Toast("定位失败");
                  console.log(err);
                  reject({
                    msg: "定位失败"
                  });
                  if (!isalertLocation) {
                    if (err.message.indexOf("Get ipLocation failed") > -1 && that.isXueXiApp()) {
                      // 学习强国 APP 没有授权定位权限
                      _Dialog.confirm({
                        title: '定位提示',
                        confirmButtonText: '手动定位',
                        cancelButtonText: "关闭",
                        message: '定位失败，请确认应用定位已授权，或请手动完成定位。'
                      }).then(function () {
                        window.location.href = that.getSiteRoot() + "/addons/yun_shop/?menu#/o2o/location/location?error=1&i=" + that.getKeyByI() + "&mid=" + that.getKeyByMid();
                      });
                      return;
                    }
                    if (err.message.indexOf("Get ipLocation failed") > -1 && (that.isApp() || that.isCPS())) {
                      // 封装APP里没获取到权限先不弹窗
                      return;
                    }
                    _Dialog.confirm({
                      title: "提示",
                      message: "\u5B9A\u4F4D\u5931\u8D25,\u662F\u5426\u8DF3\u8F6C\u624B\u52A8\u5B9A\u4F4D"
                    }).then(function () {
                      isalertLocation = true;
                      window.location.href = that.getSiteRoot() + "/addons/yun_shop/?menu#/o2o/location/location?error=1&i=" + that.getKeyByI() + "&type=" + that.getTyep() + "&mid=" + that.getKeyByMid();
                    }).catch(function () {
                      // on cancel
                      isalertLocation = true;
                    });
                  }
                };
                /**
                 * 传播大脑客户端环境：使用SDK定位替代高德AMap定位
                 * 解决客户端webview中高德JS SDK未加载导致 AMap undefined 的问题
                 */
                if (CommindSdk.isSdkAvailable()) {
                  console.log("fun.js getLocation() 使用传播大脑SDK定位");
                  CommindSdk.getLocation().then(function (pos) {
                    var point = {
                      lat: String(pos.lat),
                      lng: String(pos.lng)
                    };
                    // 组装与AMap定位相同格式的数据
                    var locationData = {
                      addressComponent: {
                        province: pos.province || "",
                        city: pos.city || "",
                        district: pos.region || ""
                      },
                      address: pos.address || "",
                      city: pos.city || "",
                      title: pos.address || point.lng + "," + point.lat,
                      point: point,
                      timestamp: Math.round(new Date() / 1000)
                    };
                    localStorage.setItem("myLocation", JSON.stringify(locationData));
                    console.log("fun.js getLocation() SDK定位成功：", locationData);
                    store.commit("updateLocation", locationData);
                    store.commit("setLocation", locationData);
                    _Toast.clear();
                    resolve(locationData);
                  }).catch(function (err) {
                    _Toast.clear();
                    console.log("fun.js getLocation() SDK定位失败:", err);
                    reject({
                      msg: "定位失败"
                    });
                  });
                  return;
                }
                if (that.isApp()) {
                  _Notify({
                    type: 'danger',
                    duration: 0,
                    message: '位置信息权限使用说明:用于查询附近、线下导航服务等场景'
                  });
                }
                var mapObj = new window.AMap.Map("iCenter");
                mapObj.plugin("AMap.Geolocation", function () {
                  var geolocation = new window.AMap.Geolocation({
                    enableHighAccuracy: true,
                    // 是否使用高精度定位，默认:true
                    timeout: 10000,
                    // 超过10秒后停止定位，默认：无穷大
                    maximumAge: 0,
                    // 定位结果缓存0毫秒，默认：0
                    convert: true,
                    // 自动偏移坐标，偏移后的坐标为高德坐标，默认：true
                    showButton: true,
                    // 显示定位按钮，默认：true
                    buttonPosition: "LB",
                    // 定位按钮停靠位置，默认：'LB'，左下角
                    buttonOffset: new window.AMap.Pixel(10, 20),
                    // 定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                    showMarker: true,
                    // 定位成功后在定位到的位置显示点标记，默认：true
                    showCircle: true,
                    // 定位成功后用圆圈表示定位精度范围，默认：true
                    panToLocation: true,
                    // 定位成功后将定位到的位置作为地图中心点，默认：true
                    zoomToAccuracy: true,
                    // 定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                    useNative: true //是否使用安卓定位sdk用来进行定位，默认：false
                  });
                  mapObj.addControl(geolocation);
                  geolocation.getCurrentPosition();
                  window.AMap.event.addListener(geolocation, "complete", onComplete); // 返回定位信息
                  window.AMap.event.addListener(geolocation, "error", onError); // 返回定位出错信息
                });
                var location_overtime = setTimeout(function () {
                  onError();
                  console.log("定位超时");
                  isOverTime = true;
                }, exitTime);
              } else {
                clearTimeout(location_overtime);
                if (loading_txt) {
                  _Toast.clear();
                }
                console.log("fun.js getLocation()定位成功,获取缓存数据：：：");
                resolve(myLocation);
              }
            }));
        }
      }, _callee3, null, [[1, 5]]);
    }))();
  },
  // 只调用一次   传入的参数是一个方法
  once: function once(fn) {
    var called = false;
    return function () {
      if (!called) {
        called = true;
        fn.apply(this, arguments);
      }
    };
  },
  isIE: function isIE() {
    return window.ActiveXObject || "ActiveXObject" in window;
  },
  numberFormat: function numberFormat(value, suffix) {
    var formatNum = parseInt(value);
    if (isNaN(formatNum)) {
      return "NaN";
    }
    var newValue = ['', '', ''];
    var num = new String(formatNum).length;
    if (num <= 4) {
      // 千
      newValue[0] = parseInt(formatNum);
      newValue[1] = '';
    } else if (num <= 8) {
      // 万
      var isMillions = num === 8;
      newValue[1] = isMillions ? '千万' : '万';
      newValue[0] = parseInt(formatNum / (isMillions ? 10000000 : 10000));
      newValue[2] = suffix;
    }
    if (formatNum < 1000) {
      newValue[0] = formatNum + '';
      newValue[1] = '';
    }
    return newValue.join('');
  },
  // 解决数字相乘失去精度
  floatMultiply: function floatMultiply(arg1, arg2) {
    if (arg1 == null || arg2 == null) {
      return null;
    }
    var n1, n2;
    var r1, r2; // 小数位数
    try {
      r1 = arg1.toString().split(".")[1].length;
    } catch (e) {
      r1 = 0;
    }
    try {
      r2 = arg2.toString().split(".")[1].length;
    } catch (e) {
      r2 = 0;
    }
    n1 = Number(arg1.toString().replace(".", ""));
    n2 = Number(arg2.toString().replace(".", ""));
    return n1 * n2 / Math.pow(10, r1 + r2);
  }
};
export default fun;